import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";
import Logo from "@/components/Logo";

export default function Navbar({ variant = "public" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = () => { logout(); navigate("/"); };

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#F5F5F5]/95 border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Logo variant="nav" testId="nav-logo" />

        {variant === "public" && !user && (
          <div className="flex items-center gap-2 sm:gap-3">
            <Link to="/blog" className="hidden md:inline-flex">
              <Button data-testid="nav-blog-btn" variant="ghost" className="rounded-full font-semibold text-[#0A1628] hover:bg-slate-100 hover:text-[#0A1628]">
                Blog
              </Button>
            </Link>
            <Link to="/about" className="hidden md:inline-flex">
              <Button data-testid="nav-about-btn" variant="ghost" className="rounded-full font-semibold text-[#0A1628] hover:bg-slate-100 hover:text-[#0A1628]">
                About
              </Button>
            </Link>
            <Link to="/contact" className="hidden md:inline-flex">
              <Button data-testid="nav-contact-btn" variant="ghost" className="rounded-full font-semibold text-[#0A1628] hover:bg-slate-100 hover:text-[#0A1628]">
                Contact
              </Button>
            </Link>
            <Link to="/login">
              <Button data-testid="nav-login-btn" variant="ghost" className="rounded-full font-semibold text-[#0A1628] hover:bg-slate-100 hover:text-[#0A1628]">
                Sign in
              </Button>
            </Link>
            <Link to="/register">
              <Button data-testid="nav-register-btn" className="rounded-full bg-brand hover:bg-brand-dark text-white font-semibold shadow-btn">
                Book a fix
              </Button>
            </Link>
          </div>
        )}

        {user && (
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline text-sm font-semibold text-[#0A1628]" data-testid="nav-user-name">
              {user.name}
            </span>
            <span className="text-[11px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 border border-blue-200">
              {user.role}
            </span>
            <Button data-testid="nav-logout-btn" onClick={doLogout} variant="outline" size="sm" className="rounded-full border border-slate-300 bg-white text-[#0A1628] hover:bg-slate-100 hover:text-[#0A1628] font-semibold">
              <LogOut className="w-4 h-4 mr-1" /> Sign out
            </Button>
          </div>
        )}
      </div>
    </header>
  );
}
